import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import * as _ from 'underscore';

import { Profile } from './profile';
import { ProfileElement } from './profileelement';
import { SessionService } from '../session/session.service';
import { GenericdatasetSettings } from '../genericdataset/genericdataset.settings';

import { Profils } from './profils';

declare const $: any;

@Injectable()
export class ProfileService {
  public profiles: any[] = (<any>Profils);
  public profile: Profile = new Profile();
  public profileUrl: string = GenericdatasetSettings.api_endpoint + 'profiles';
  public profileElementUrl: string = GenericdatasetSettings.api_endpoint + 'profileelements';
  public headers = new Headers({ 'Content-Type': 'application/json' });
  public options = new RequestOptions({ headers: this.headers });

  constructor(public http: Http, public sessionService: SessionService, public router: Router) {
    this.sessionService.session.subscribe((data) => {
      if (data.users.profile) {
        this.setProfileByName(data.users.profile);
      }
    }, (err) => { });
  }
  public setProfile(profile: any) {
    this.profile = profile;
    setTimeout(() => $('.collapsible').collapsible(), 1000);
    this.sessionService.setProfile(this.profile.name);
    this.router.navigate([profile.link]);
  }
  public setProfileByName(name: string) {
    let profile = _.findWhere(this.profiles, { name: name });
    if (!profile && this.profiles.length > 0) profile = this.profiles[0];
    this.profile = profile;
    setTimeout(() => $('.collapsible').collapsible(), 1000);
  }
  public addProfile(item: any): Observable<any> {
    const body = JSON.stringify(item);
    return this.http.post(this.profileUrl, body, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public updateProfile(item: any): Observable<any> {
    const profileUrl = this.profileUrl + '/' + item.id;
    const body = JSON.stringify(item);
    return this.http.put(profileUrl, body, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public getProfile(id: number): Observable<any> {
    const profileUrl = this.profileUrl + '/' + id;
    return this.http.get(profileUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public extractData(res: Response) {
    const body = res.json();
    return body;
  }
  public handleError(error: any) {
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    return Observable.throw(errMsg);
  }

}
